import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { liveChat } from "@jti/fe-clients";
import { Icon } from "../../components/Icon/Icon";
import LogoutIcon from "../../icons/logout.svg";
import { useTranslations } from "../../providers/useTranslations";
import styles from "./SignOut.module.scss";
var iconColors;
(function (iconColors) {
    iconColors["primary"] = "FFB990";
    iconColors["secondary"] = "373A36";
})(iconColors || (iconColors = {}));
export const SignOut = ({ logout, className, type }) => {
    const { __ } = useTranslations();
    const [disableLogout, setDisableLogout] = useState(false);
    const logoutHandler = useCallback(() => {
        setDisableLogout(true);
        logout().finally(() => {
            setDisableLogout(false);
            liveChat.onLogout();
        });
    }, [logout]);
    return (_jsxs("button", { "data-testid": "signOutButton", className: `${styles.wrap} ${className ? className : ""}`, onClick: logoutHandler, disabled: disableLogout, children: [_jsx("span", { className: `${styles.text} ${styles["type-" + type]}`, children: __("libs.ui.sign_out") }), _jsx(Icon, { component: () => _jsx(LogoutIcon, { fill: `#${iconColors[type]}` }) })] }));
};
//# sourceMappingURL=SignOut.js.map